var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3145 7.64551C17.3145 7.37305 17.2002 7.10938 16.998 6.91602L11.2236 1.1416C10.9951 0.921875 10.7578 0.825195 10.5117 0.825195C9.94922 0.825195 9.54492 1.2207 9.54492 1.75684C9.54492 2.03809 9.65918 2.27539 9.83496 2.45117L11.8125 4.45508L14.3613 6.78418L12.3223 6.66113H1.66992C1.08105 6.66113 0.676758 7.06543 0.676758 7.64551C0.676758 8.2168 1.08105 8.62109 1.66992 8.62109H12.3223L14.3613 8.49805L11.8125 10.8271L9.83496 12.8311C9.65918 13.0068 9.54492 13.2441 9.54492 13.5254C9.54492 14.0615 9.94922 14.457 10.5117 14.457C10.7578 14.457 10.9951 14.3604 11.2061 14.1582L16.998 8.36621C17.2002 8.17285 17.3145 7.90918 17.3145 7.64551Z",
    fill: "#0A2458"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlue);
export default __webpack_public_path__ + "static/media/arrow-blue.30f82b24e9dd6ceb204eee3f75c2369a.svg";
export { ForwardRef as ReactComponent };